import * as React from "react";
import { observer } from "mobx-react";
import { useLocalization } from "@shared-ui/localization-context";
import { LocationField } from "src/components/shared/LocationField/LocationField";
import { DestinationFieldConfig } from "src/stores/wizard/config/typings";
import { LocationFieldConfig } from "src/stores/wizard/config";
import { TypeaheadSelection } from "uitk-react-typeahead";
import { ContextStore } from "bernie-core";
import { Location } from "src/stores/wizard/state/global/location/typings";
import { UitkLayoutGridItem, UitkLayoutConditionalGridSpan } from "uitk-react-layout-grid";

export interface GroundTransportLocationFieldProps {
  fieldConfig: DestinationFieldConfig | LocationFieldConfig;
  context: ContextStore;
  fieldInvalidKey: string;
  location: Location;
  onLocationFieldUpdate: (selection: TypeaheadSelection) => void;
  setInputsRefs?: (ref: React.RefObject<HTMLInputElement>) => void;
  track?(event: string): void;
  trackId: string;
  colSpan: UitkLayoutConditionalGridSpan;
}

export const GroundTransportLocationField: React.FunctionComponent<GroundTransportLocationFieldProps> = observer(
  (props) => {
    const {
      fieldConfig,
      context,
      onLocationFieldUpdate,
      fieldInvalidKey,
      location,
      setInputsRefs,
      track,
      trackId,
      colSpan,
    } = props;
    const { formatText } = useLocalization();

    return (
      <UitkLayoutGridItem colSpan={colSpan}>
        <div>
          <LocationField
            context={context}
            onUpdate={onLocationFieldUpdate}
            icon={fieldConfig.icon}
            name={fieldConfig.inputName}
            label={formatText(fieldConfig.labelToken)}
            typeaheadPlaceholder={formatText(fieldConfig.typeaheadLabelToken!)}
            invalid={formatText(fieldInvalidKey)}
            value={location.value}
            essAdapterConfig={fieldConfig.essAdapterConfig}
            stid={`location-field-${fieldConfig.inputName}`}
            config={fieldConfig!}
            location={location}
            setInputsRefs={setInputsRefs}
            track={track}
            trackId={trackId}
          />
        </div>
      </UitkLayoutGridItem>
    );
  }
);
